/* eslint-disable import/prefer-default-export */
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  appBar: {
    position: 'relative',
    background: '#005a87',
  },
}))
